// extracted by mini-css-extract-plugin
export default {"viewProposal":"view-proposal_viewProposal__5s-Cx","viewProposalContainer":"view-proposal_viewProposalContainer__0J02u"};